module.exports = "pegasus/assets/blocks/column-14-theme6.png";